import React,{ Component } from 'react';

import FloatingWindowLayout from '../../../shared/components/FloatingWindowLayout';
import Button from '../../../shared/components/Button';
import TextInput from '../../../shared/components/TextInput';
import Form from '../../../shared/components/Form';
import VersionTag from '../../../shared/components/VersionTag';

import { ACTIVE_PROFILE } from '../../../config';

class ForgotPassword extends Component {
  constructor(){
    super();

    this.state = {
      sending:false,
      error:null,
      sent:false,
      email:null,
      mailTo:'mailto:admin@getdabbl.com?Subject=I%20need%20help%20resetting%20my%20password'
    };
  }

  componentDidMount(){
    this.hideChatBox();
  }

  componentDidUpdate(){
    this.hideChatBox();
  }

  handleSubmit(data){
    const { email } = data;

    this.setState({sending:true,email:email});
    this.props.requestResetLinkForEmail(email)
      .then(() => this.handleSuccess())
      .catch((err) => this.handleError(err))
  }

  handleSuccess(){
    this.setState({
      sent:true,
      sending:false
    });
  }

  handleError(error){
    this.setState({
      error:error,
      sending:false
    });
  }

  hideChatBox(){
    const chatElement = document.getElementById('lc_chat_layout');

    if(chatElement){
      chatElement.style.display = 'none';
    }
  }

  render(){
    const {
      environment,
      frontEndVersion,
      backEndVersion
    } = this.props;

    if(this.state.sent){
      return (
        <div className='FloatingWindowLayoutBackdrop'>
          {ACTIVE_PROFILE !== 'prod' && ( 
            <VersionTag 
              environment={environment}
              frontend={frontEndVersion}
              backend={backEndVersion}
            /> 
          )}  
          <FloatingWindowLayout title='Reset Password'>
            <p>
              A temporary password reset link has been sent to {this.state.email}.  If you need any additional help, contact us at <a href={this.state.mailTo}>admin@getdabbl.com</a>
            </p>
          </FloatingWindowLayout>
        </div>
      )
    }


    return (
      <div className='FloatingWindowLayoutBackdrop'>
        {ACTIVE_PROFILE !== 'prod' && ( 
          <VersionTag 
            environment={environment}
            frontend={frontEndVersion}
            backend={backEndVersion}
          /> 
        )}  
        <FloatingWindowLayout title='Reset Password'>
          {this.state.error && (
            <div>
              <div className='FormError'>
                <span>User is invalid and can not be reset.</span>
                <br />
                <span>Contact us at <a href={this.state.mailTo}>admin@getdabbl.com</a> for more info.</span>
              </div>
              <br />
            </div>
          )}
          <Form onSubmit={(data) => this.handleSubmit(data)}>
            <TextInput label='Email' name='email' type='email' />
            <Button className='float-right' isSubmit>
              Submit
            </Button>
          </Form>
        </FloatingWindowLayout>
      </div>
    )
  }
}

export default ForgotPassword;



// WEBPACK FOOTER //
// ./src/routes/ForgotPassword/components/ForgotPassword.js